<template>
    <div class="nscp-new-sup-check-audit">
        <div class="title">新供应商点检审批<span class="tip">注意：在提交点检审批流程时必须上传点检附件！请确保已下载模板并填写完成。</span></div>
        <SupBaseInfo v-if="baseInfoVisible" :supplierParams="supplierParams" :auditId="auditId" />
        <ContractInfo v-if="contractVisible" :info="contractInfo" />
        <AttachmentInfo v-if="attachmentVisible" ref="amRef" :info="attachmentInfo" :auditStatus="auditStatus" />
    </div>
</template>
<script>
import { selectByAuditId } from '../../../api/newSupCheckPool.js';
import SupBaseInfo from '../../../views/register/manage/keyData/detail/components/SupBaseInfo.vue';
import ContractInfo from './ContractInfo.vue';
import AttachmentInfo from './AttachmentInfo.vue';
export default {
    components: { SupBaseInfo, ContractInfo, AttachmentInfo },
    props: {
        auditId: {
            type: String,
            default: ''
        },
        auditStatus: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            // 供应商信息参数
            supplierParams: {
                id: '',
                businessType: '',
                supplierCode: '',
                propertyNature: '',
            },
            baseInfoVisible: false,
            contractVisible: false,
            attachmentVisible: false,
            contractInfo: {
                contractCode: '',
                contractName: '',
                supplierName: '',
                effectiveDate: '',
                contractSiteName: '',
                contractCompanyName: '',
            },
            attachmentInfo: {
                spotCheckCode: '',
                spotCheckFileId: '',
                spotCheckFileUrl: '',
                spotCheckFileName: '',
            },
        };
    },
    methods: {
        setSupplierParams() {
            selectByAuditId({ auditId: this.auditId }).then(res => {
                if (res && +res.code === 0) {
                    if (res.data) {
                        ['supplierInfoId', 'contractBusinessType', 'supplierCode', 'propertyNature'].forEach(key => {
                            if (!['', null, undefined].includes(res.data[key])) {
                                if (key === 'supplierInfoId') {
                                    this.supplierParams.id = res.data[key]
                                } else if (key === 'contractBusinessType') {
                                    this.supplierParams.businessType = res.data[key]
                                } else {
                                    this.supplierParams[key] = res.data[key]
                                }
                            }
                        })

                        this.contractInfo.contractCode = res.data.contractCode
                        this.contractInfo.contractName = res.data.contractName
                        this.contractInfo.supplierName = res.data.supplierName
                        this.contractInfo.effectiveDate = res.data.effectiveDate
                        this.contractInfo.contractSiteName = res.data.contractSiteName
                        this.contractInfo.contractCompanyName = res.data.contractCompanyName

                        this.attachmentInfo.spotCheckCode = res.data.spotCheckCode
                        this.attachmentInfo.spotCheckFileId = res.data.spotCheckFileId
                        this.attachmentInfo.spotCheckFileUrl = res.data.spotCheckFileUrl
                        this.attachmentInfo.spotCheckFileName = res.data.spotCheckFileName
                    }
                    this.baseInfoVisible = true
                    this.contractVisible = true
                    this.attachmentVisible = true
                }
            }).catch(err => {})
        },
        uploadValidate() {
            let valid = false
            if (this.$refs.amRef && this.$refs.amRef.uploadValidate()) {
                valid = true
            }
            return valid
        },
    },
    mounted() {
        this.setSupplierParams()
    },
};
</script>
<style lang="less" scoped>
.nscp-new-sup-check-audit {
    color: #000;

    .title {
        margin-bottom: 15px;
        font-size: 16px;
        font-weight: bold;
    }

    .tip {
        color: red;
        font-size: 12px;
        font-weight: normal;
        display: inline-block;
        margin-left: 10px;
    }
}
</style>
